// extracted by mini-css-extract-plugin
module.exports = {"HorizontalCards":"Strategies-module__HorizontalCards___V2G3H","HorizontalCard":"Strategies-module__HorizontalCard___1nTjX"};